msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/admin/pages/DashboardPage.tsx
msgid "(empty — v0 orphan)"
msgstr "(empty — v0 orphan)"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "(empty)"
msgstr "(empty)"

#. placeholder {0}: formatNumber(i18n, snap.p50_ms)
#. placeholder {0}: formatNumber(i18n, snap.p95_ms)
#. placeholder {0}: formatNumber(i18n, snap.p99_ms)
#: src/admin/pages/HeartbeatLagPage.tsx
msgid "{0} ms"
msgstr "{0} ms"

#: src/admin/pages/UserDetailPage.tsx
msgid "{disabledAgentCount, plural, one {# agent is disabled.} other {# agents are disabled.}} Enabling this account does not enable them — open each agent to enable it."
msgstr "{disabledAgentCount, plural, one {# agent is disabled.} other {# agents are disabled.}} Enabling this account does not enable them — open each agent to enable it."

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "⚠️ Above threshold"
msgstr "⚠️ Above threshold"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "✅ Normal"
msgstr "✅ Normal"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Account"
msgstr "Account"

#: src/admin/pages/UserDetailPage.tsx
msgid "Account disabled"
msgstr "Account disabled"

#: src/admin/pages/UserDetailPage.tsx
msgid "Account enabled"
msgstr "Account enabled"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/InvitesPage.tsx
msgid "Actions"
msgstr "Actions"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/InvitesPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Active"
msgstr "Active"

#: src/admin/pages/DashboardPage.tsx
msgid "Admin-only visibility. Not exposed to end-users."
msgstr "Admin-only visibility. Not exposed to end-users."

#: src/admin/messages.ts
msgid "Agent"
msgstr "Agent"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Agent disabled"
msgstr "Agent disabled"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Agent enabled"
msgstr "Agent enabled"

#: src/admin/pages/RuntimesPage.tsx
msgid "Agent ID"
msgstr "Agent ID"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Agent not found"
msgstr "Agent not found"

#. placeholder {0}: formatNumber(i18n, agents.length)
#: src/admin/pages/UserDetailPage.tsx
msgid "Agents ({0})"
msgstr "Agents ({0})"

#. placeholder {0}: owner.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "An agent can only be active while its owner is. Enable <0>{0}</0> first, then enable this agent here."
msgstr "An agent can only be active while its owner is. Enable <0>{0}</0> first, then enable this agent here."

#: src/admin/pages/AgentDetailPage.tsx
msgid "API Key"
msgstr "API Key"

#: src/admin/pages/SettingsPage.tsx
msgid "API Prefix"
msgstr "API Prefix"

#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "Archived At"
msgstr "Archived At"

#: src/admin/AdminApp.tsx
msgid "Archived Channels"
msgstr "Archived Channels"

#. placeholder {0}: formatNumber(i18n, channels.length)
#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "Archived Channels ({0})"
msgstr "Archived Channels ({0})"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Back"
msgstr "Back"

#: src/admin/AdminApp.tsx
#: src/admin/pages/LoginPage.tsx
msgid "Borgee Admin"
msgstr "Borgee Admin"

#: src/admin/confirm.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Cancel"
msgstr "Cancel"

#. placeholder {0}: formatNumber(i18n, permissions.length)
#: src/admin/pages/AgentDetailPage.tsx
msgid "Capabilities ({0})"
msgstr "Capabilities ({0})"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Capability"
msgstr "Capability"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Changes"
msgstr "Changes"

#: src/admin/messages.ts
msgid "Channel"
msgstr "Channel"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Channel ID"
msgstr "Channel ID"

#: src/admin/AdminApp.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/DashboardPage.tsx
msgid "Channels"
msgstr "Channels"

#. placeholder {0}: formatNumber(i18n, channels.length)
#: src/admin/pages/UserDetailPage.tsx
msgid "Channels ({0})"
msgstr "Channels ({0})"

#: src/admin/pages/InvitesPage.tsx
msgid "Code"
msgstr "Code"

#: src/admin/pages/UsersPage.tsx
msgid "Create"
msgstr "Create"

#: src/admin/pages/UsersPage.tsx
msgid "Create an account for <0>{displayName}</0> at <1>{email}</1>? They can sign in with the password entered here right away. The server also provisions around them: their own org, a personal Project holding <2>#general</2> and <3>#welcome</3> that they are joined to, a welcome post in it, and the unrestricted <4>(*, *)</4> capability grant every member gets."
msgstr "Create an account for <0>{displayName}</0> at <1>{email}</1>? They can sign in with the password entered here right away. The server also provisions around them: their own org, a personal Project holding <2>#general</2> and <3>#welcome</3> that they are joined to, a welcome post in it, and the unrestricted <4>(*, *)</4> capability grant every member gets."

#: src/admin/pages/UsersPage.tsx
msgid "Create User"
msgstr "Create User"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/InvitesPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Created"
msgstr "Created"

#: src/admin/AdminApp.tsx
#: src/admin/pages/DashboardPage.tsx
msgid "Dashboard"
msgstr "Dashboard"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Delete"
msgstr "Delete"

#. placeholder {0}: user.display_name
#: src/admin/pages/UserDetailPage.tsx
msgid "Delete <0>{0}</0>? Their sessions end, their channel memberships are dropped, and every agent they own is deleted with them. Messages they already sent stay, still under their name. This console has no way back."
msgstr "Delete <0>{0}</0>? Their sessions end, their channel memberships are dropped, and every agent they own is deleted with them. Messages they already sent stay, still under their name. This console has no way back."

#: src/admin/pages/AgentDetailPage.tsx
msgid "Delete Agent"
msgstr "Delete Agent"

#. placeholder {0}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Delete agent <0>{0}</0>? Its API key and capability grants die with it, and a deleted agent can never be restored — bringing this one back means creating a new agent."
msgstr "Delete agent <0>{0}</0>? Its API key and capability grants die with it, and a deleted agent can never be restored — bringing this one back means creating a new agent."

#: src/admin/pages/UserDetailPage.tsx
msgid "Delete User"
msgstr "Delete User"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Deleted"
msgstr "Deleted"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Description History"
msgstr "Description History"

#: src/admin/messages.ts
msgid "Direct Message"
msgstr "Direct Message"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Disable"
msgstr "Disable"

#. placeholder {0}: user.display_name
#: src/admin/pages/UserDetailPage.tsx
msgid "Disable <0>{0}</0>? They lose access immediately, and every agent they own is disabled with them."
msgstr "Disable <0>{0}</0>? They lose access immediately, and every agent they own is disabled with them."

#: src/admin/pages/UserDetailPage.tsx
msgid "Disable Account"
msgstr "Disable Account"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Disable Agent"
msgstr "Disable Agent"

#. placeholder {0}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Disable agent <0>{0}</0>? Its API key stops working at once and any live connection is dropped."
msgstr "Disable agent <0>{0}</0>? Its API key stops working at once and any live connection is dropped."

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Disabled"
msgstr "Disabled"

#: src/admin/pages/UsersPage.tsx
msgid "Display Name"
msgstr "Display Name"

#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Email"
msgstr "Email"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Enable"
msgstr "Enable"

#. placeholder {0}: user.display_name
#: src/admin/pages/UserDetailPage.tsx
msgid "Enable <0>{0}</0>? They regain access immediately. Agents they own stay disabled until each one is enabled on its own page."
msgstr "Enable <0>{0}</0>? They regain access immediately. Agents they own stay disabled until each one is enabled on its own page."

#: src/admin/pages/UserDetailPage.tsx
msgid "Enable Account"
msgstr "Enable Account"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Enable Agent"
msgstr "Enable Agent"

#. placeholder {0}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Enable agent <0>{0}</0>? It can connect and act with its granted capabilities again."
msgstr "Enable agent <0>{0}</0>? It can connect and act with its granted capabilities again."

#. placeholder {0}: session.login
#: src/admin/LogoutButton.tsx
msgid "End the admin session for <0>{0}</0>? Signing back in is required to reach the console again."
msgstr "End the admin session for <0>{0}</0>? Signing back in is required to reach the console again."

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/RuntimesPage.tsx
msgid "Endpoint"
msgstr "Endpoint"

#: src/admin/messages.ts
msgid "Error"
msgstr "Error"

#: src/admin/pages/InvitesPage.tsx
msgid "Expired"
msgstr "Expired"

#: src/admin/pages/InvitesPage.tsx
msgid "Expires"
msgstr "Expires"

#: src/admin/pages/InvitesPage.tsx
msgid "Expires In Hours"
msgstr "Expires In Hours"

#: src/admin/pages/InvitesPage.tsx
msgid "Failed to create invite"
msgstr "Failed to create invite"

#: src/admin/pages/UsersPage.tsx
msgid "Failed to create user"
msgstr "Failed to create user"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to delete agent"
msgstr "Failed to delete agent"

#: src/admin/pages/UserDetailPage.tsx
msgid "Failed to delete user"
msgstr "Failed to delete user"

#: src/admin/pages/ChannelsPage.tsx
msgid "Failed to force delete channel"
msgstr "Failed to force delete channel"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to grant capability"
msgstr "Failed to grant capability"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to load agent"
msgstr "Failed to load agent"

#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "Failed to load archived channels"
msgstr "Failed to load archived channels"

#: src/admin/pages/ChannelsPage.tsx
msgid "Failed to load channels"
msgstr "Failed to load channels"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Failed to load heartbeat lag"
msgstr "Failed to load heartbeat lag"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Failed to load history"
msgstr "Failed to load history"

#: src/admin/pages/InvitesPage.tsx
msgid "Failed to load invites"
msgstr "Failed to load invites"

#: src/admin/pages/RuntimesPage.tsx
msgid "Failed to load runtimes"
msgstr "Failed to load runtimes"

#: src/admin/pages/DashboardPage.tsx
msgid "Failed to load stats"
msgstr "Failed to load stats"

#: src/admin/pages/UserDetailPage.tsx
msgid "Failed to load user"
msgstr "Failed to load user"

#: src/admin/pages/UsersPage.tsx
msgid "Failed to load users"
msgstr "Failed to load users"

#: src/admin/pages/UserDetailPage.tsx
msgid "Failed to reset password"
msgstr "Failed to reset password"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to revoke capability"
msgstr "Failed to revoke capability"

#: src/admin/pages/InvitesPage.tsx
msgid "Failed to revoke invite"
msgstr "Failed to revoke invite"

#: src/admin/pages/UserDetailPage.tsx
msgid "Failed to update account"
msgstr "Failed to update account"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Failed to update agent"
msgstr "Failed to update agent"

#: src/admin/pages/ChannelsPage.tsx
msgid "Force Delete"
msgstr "Force Delete"

#. placeholder {0}: channel.name
#: src/admin/pages/ChannelsPage.tsx
msgid "Force delete <0>#{0}</0>? Every member loses the channel at once, and its memberships and channel-scoped grants are dropped for good. Messages are not deleted — they stay in the database, unreachable through this server. Nothing in this console brings the channel back."
msgstr "Force delete <0>#{0}</0>? Every member loses the channel at once, and its memberships and channel-scoped grants are dropped for good. Messages are not deleted — they stay in the database, unreachable through this server. Nothing in this console brings the channel back."

#: src/admin/pages/ChannelsPage.tsx
msgid "Force Delete Channel"
msgstr "Force Delete Channel"

#: src/admin/pages/InvitesPage.tsx
msgid "Generate"
msgstr "Generate"

#: src/admin/pages/InvitesPage.tsx
msgid "Generate a signup invite code noted <0>{note}</0>? Anyone holding it can create one account on this server."
msgstr "Generate a signup invite code noted <0>{note}</0>? Anyone holding it can create one account on this server."

#: src/admin/pages/InvitesPage.tsx
msgid "Generate a signup invite code? Anyone holding it can create one account on this server."
msgstr "Generate a signup invite code? Anyone holding it can create one account on this server."

#: src/admin/pages/InvitesPage.tsx
msgid "Generate Invite Code"
msgstr "Generate Invite Code"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Grant"
msgstr "Grant"

#. placeholder {0}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Grant <0><1/></0> on scope <2>{scope}</2> to <3>{0}</3>? The agent can use it from its next action on."
msgstr "Grant <0><1/></0> on scope <2>{scope}</2> to <3>{0}</3>? The agent can use it from its next action on."

#: src/admin/pages/AgentDetailPage.tsx
msgid "Grant Capability"
msgstr "Grant Capability"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Granted"
msgstr "Granted"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Granted <0/> ({scope})"
msgstr "Granted <0/> ({scope})"

#: src/admin/AdminApp.tsx
#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Heartbeat Lag"
msgstr "Heartbeat Lag"

#: src/admin/messages.ts
msgid "Hermes"
msgstr "Hermes"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/SettingsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "ID"
msgstr "ID"

#: src/admin/messages.ts
msgid "Invalid API key"
msgstr "Invalid API key"

#: src/admin/AdminApp.tsx
#: src/admin/pages/InvitesPage.tsx
msgid "Invites"
msgstr "Invites"

#: src/admin/pages/InvitesPage.tsx
msgid "It stays usable for <0>{lifetimeHours, plural, one {# hour} other {# hours}}</0>."
msgstr "It stays usable for <0>{lifetimeHours, plural, one {# hour} other {# hours}}</0>."

#: src/admin/pages/InvitesPage.tsx
msgid "It stays usable until it is used or revoked."
msgstr "It stays usable until it is used or revoked."

#: src/admin/pages/AgentDetailPage.tsx
msgid "Last Connected"
msgstr "Last Connected"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/RuntimesPage.tsx
msgid "Last Heartbeat"
msgstr "Last Heartbeat"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Last Plugin"
msgstr "Last Plugin"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Last Seen"
msgstr "Last Seen"

#: src/admin/LogoutButton.tsx
msgid "Log Out"
msgstr "Log Out"

#: src/admin/pages/LoginPage.tsx
#: src/admin/pages/SettingsPage.tsx
msgid "Login"
msgstr "Login"

#: src/admin/LogoutButton.tsx
msgid "Logout"
msgstr "Logout"

#: src/admin/messages.ts
msgid "Member"
msgstr "Member"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Members"
msgstr "Members"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Name"
msgstr "Name"

#: src/admin/messages.ts
msgid "Network unreachable"
msgstr "Network unreachable"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Never"
msgstr "Never"

#: src/admin/pages/InvitesPage.tsx
msgid "Never expires"
msgstr "Never expires"

#: src/admin/pages/UserDetailPage.tsx
msgid "New Password"
msgstr "New Password"

#: src/admin/pages/UserDetailPage.tsx
msgid "No agents"
msgstr "No agents"

#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "No archived channels"
msgstr "No archived channels"

#: src/admin/pages/AgentDetailPage.tsx
msgid "No capabilities granted"
msgstr "No capabilities granted"

#: src/admin/pages/UserDetailPage.tsx
msgid "No channels"
msgstr "No channels"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "No data"
msgstr "No data"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "No history"
msgstr "No history"

#: src/admin/pages/InvitesPage.tsx
msgid "No invite codes"
msgstr "No invite codes"

#: src/admin/pages/DashboardPage.tsx
msgid "No org rows reported by /stats."
msgstr "No org rows reported by /stats."

#: src/admin/pages/AgentDetailPage.tsx
msgid "No runtime registered"
msgstr "No runtime registered"

#: src/admin/pages/RuntimesPage.tsx
msgid "No runtimes"
msgstr "No runtimes"

#: src/admin/pages/UsersPage.tsx
msgid "No users"
msgstr "No users"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Not set"
msgstr "Not set"

#: src/admin/pages/InvitesPage.tsx
msgid "Note"
msgstr "Note"

#: src/admin/pages/DashboardPage.tsx
msgid "Online"
msgstr "Online"

#: src/admin/messages.ts
msgid "OpenClaw"
msgstr "OpenClaw"

#: src/admin/pages/InvitesPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "optional"
msgstr "optional"

#: src/admin/pages/DashboardPage.tsx
msgid "Organizations (debug)"
msgstr "Organizations (debug)"

#: src/admin/pages/DashboardPage.tsx
msgid "Orgs"
msgstr "Orgs"

#. placeholder {0}: user.display_name
#: src/admin/pages/UserDetailPage.tsx
msgid "Overwrite the password for <0>{0}</0>? The current password cannot be recovered, and their signed-in sessions end immediately."
msgstr "Overwrite the password for <0>{0}</0>? The current password cannot be recovered, and their signed-in sessions end immediately."

#: src/admin/pages/AgentDetailPage.tsx
msgid "Owner"
msgstr "Owner"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "P50"
msgstr "P50"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "P95"
msgstr "P95"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "P99"
msgstr "P99"

#: src/admin/pages/LoginPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Password"
msgstr "Password"

#: src/admin/pages/UserDetailPage.tsx
msgid "Password reset"
msgstr "Password reset"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Previous Content"
msgstr "Previous Content"

#: src/admin/messages.ts
msgid "Private"
msgstr "Private"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/RuntimesPage.tsx
msgid "Process"
msgstr "Process"

#: src/admin/messages.ts
msgid "Public"
msgstr "Public"

#: src/admin/messages.ts
msgid "Quota exceeded"
msgstr "Quota exceeded"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Reason"
msgstr "Reason"

#. placeholder {0}: semanticLabel(i18n, snap.reason_if_at_risk)
#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Reason: {0}"
msgstr "Reason: {0}"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/HeartbeatLagPage.tsx
#: src/admin/pages/RuntimesPage.tsx
msgid "Refresh"
msgstr "Refresh"

#: src/admin/messages.ts
msgid "Registered"
msgstr "Registered"

#: src/admin/pages/UserDetailPage.tsx
msgid "Reset Password"
msgstr "Reset Password"

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/InvitesPage.tsx
msgid "Revoke"
msgstr "Revoke"

#. placeholder {0}: perm.scope
#. placeholder {1}: agent.display_name
#: src/admin/pages/AgentDetailPage.tsx
msgid "Revoke <0><1/></0> on scope <2>{0}</2> from <3>{1}</3>? The agent is denied it on its next action, and work already in flight is not interrupted. Delivery lags behind: a connected agent can still be handed message bodies it has just lost the right to read, for up to the channel-access cache lifetime (2 seconds by default)."
msgstr "Revoke <0><1/></0> on scope <2>{0}</2> from <3>{1}</3>? The agent is denied it on its next action, and work already in flight is not interrupted. Delivery lags behind: a connected agent can still be handed message bodies it has just lost the right to read, for up to the channel-access cache lifetime (2 seconds by default)."

#: src/admin/pages/AgentDetailPage.tsx
msgid "Revoke Capability"
msgstr "Revoke Capability"

#: src/admin/pages/InvitesPage.tsx
msgid "Revoke Invite Code"
msgstr "Revoke Invite Code"

#: src/admin/pages/InvitesPage.tsx
msgid "Revoke invite code <0>{code}</0>? Anyone still holding it can no longer sign up with it, and the code cannot be restored."
msgstr "Revoke invite code <0>{code}</0>? Anyone still holding it can no longer sign up with it, and the code cannot be restored."

#. placeholder {0}: perm.scope
#: src/admin/pages/AgentDetailPage.tsx
msgid "Revoked <0/> ({0})"
msgstr "Revoked <0/> ({0})"

#: src/admin/pages/UserDetailPage.tsx
msgid "Role"
msgstr "Role"

#: src/admin/messages.ts
msgid "Running"
msgstr "Running"

#. placeholder {0}: formatNumber(i18n, runtimes.length)
#: src/admin/pages/AgentDetailPage.tsx
msgid "Runtime ({0})"
msgstr "Runtime ({0})"

#: src/admin/messages.ts
msgid "Runtime crashed"
msgstr "Runtime crashed"

#: src/admin/messages.ts
msgid "Runtime timed out"
msgstr "Runtime timed out"

#: src/admin/AdminApp.tsx
msgid "Runtimes"
msgstr "Runtimes"

#. placeholder {0}: formatNumber(i18n, runtimes.length)
#: src/admin/pages/RuntimesPage.tsx
msgid "Runtimes ({0})"
msgstr "Runtimes ({0})"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Sampled At"
msgstr "Sampled At"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Samples"
msgstr "Samples"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Scope"
msgstr "Scope"

#: src/admin/AdminApp.tsx
#: src/admin/pages/SettingsPage.tsx
msgid "Settings"
msgstr "Settings"

#: src/admin/pages/LoginPage.tsx
msgid "Sign in"
msgstr "Sign in"

#: src/admin/pages/LoginPage.tsx
msgid "Signed out of this browser, but the server never confirmed it. That admin session may still be live."
msgstr "Signed out of this browser, but the server never confirmed it. That admin session may still be live."

#: src/admin/pages/LoginPage.tsx
msgid "Signing in..."
msgstr "Signing in..."

#: src/admin/pages/AgentDetailPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/HeartbeatLagPage.tsx
#: src/admin/pages/InvitesPage.tsx
#: src/admin/pages/RuntimesPage.tsx
#: src/admin/pages/UserDetailPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Status"
msgstr "Status"

#: src/admin/messages.ts
msgid "Stopped"
msgstr "Stopped"

#: src/admin/messages.ts
msgid "System"
msgstr "System"

#: src/admin/pages/LoginPage.tsx
msgid "Technical details"
msgstr "Technical details"

#: src/admin/pages/AgentDetailPage.tsx
msgid "This server offers no way to grant this capability back"
msgstr "This server offers no way to grant this capability back"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Threshold"
msgstr "Threshold"

#: src/admin/pages/ChannelDescriptionHistoryPage.tsx
msgid "Time"
msgstr "Time"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Token"
msgstr "Token"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Type"
msgstr "Type"

#: src/admin/messages.ts
msgid "Unknown ({code})"
msgstr "Unknown ({code})"

#: src/admin/pages/AgentDetailPage.tsx
msgid "Unknown capability: {grantCapability}"
msgstr "Unknown capability: {grantCapability}"

#: src/admin/messages.ts
msgid "Unknown reason"
msgstr "Unknown reason"

#: src/admin/pages/InvitesPage.tsx
msgid "Used"
msgstr "Used"

#: src/admin/pages/UsersPage.tsx
msgid "User ID"
msgstr "User ID"

#: src/admin/pages/UserDetailPage.tsx
msgid "User not found"
msgstr "User not found"

#: src/admin/AdminApp.tsx
#: src/admin/pages/DashboardPage.tsx
#: src/admin/pages/UsersPage.tsx
msgid "Users"
msgstr "Users"

#: src/admin/pages/ArchivedChannelsPage.tsx
msgid "View"
msgstr "View"

#: src/admin/pages/ArchivedChannelsPage.tsx
#: src/admin/pages/ChannelsPage.tsx
#: src/admin/pages/UserDetailPage.tsx
msgid "Visibility"
msgstr "Visibility"

#: src/admin/pages/HeartbeatLagPage.tsx
msgid "Window"
msgstr "Window"

#: src/admin/messages.ts
msgid "Zone"
msgstr "Zone"
